import React, { useEffect, useState } from "react";

import { StyleSheet, View, Text, TouchableOpacity, Platform } from "react-native";

import moment from "moment";

import { getMoodById } from "../../common/mood/MoodsHelper";
import { getEncKey, decryptField } from "../../../../helpers/utils";
import ManaTextMore from "../../common/ManaTextMore";

import ImageComponent from "../../common/ImageComponent";
import ManaHourMinutes from "../../common/ManaHourMinutes";
import AppTheme from "../../AppTheme";
import RoundCheckbox from "../../common/RoundCheckbox";

export default function EditReflectionGem({
  item,
  goal,
  element,
  editGemId,
  index,
  openEditMenuOptions,
  toggleGemSelection,
  controller,
  showAll = false,
  titleStyle = {},
  inReportMode = false,
}) {
  const [isCollapsed, setIsCollapsed] = useState(!showAll);
  const [isSelected, setIsSelected] = useState(item.isSelected);

  const {
    mood,
    day,
    time_unit,
    hours,
    text,
    datetime_created,
    datetime_timeslot,
    duration = 15,
  } = item;

  useEffect(() => {
    setIsSelected(item.isSelected);
  }, [item.isSelected]);

  // ------------------------------------- METHODS -------------------------------------
  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getIntervalTitle = () => {
    if (!time_unit) return "";
    const gemType = time_unit == "mana" ? "track" : "";
    const gemDate = time_unit == "mana" ? datetime_timeslot : day;

    const dayStartGem = moment(gemDate);
    const dayEndGem =
      time_unit === "mana"
        ? dayStartGem.clone().add(duration, "minutes")
        : dayStartGem
            .clone()
            .add(1, time_unit + "s")
            .add(-1, "days");

    let [startMonth, startDay] = [
      dayStartGem.format("MMM"),
      dayStartGem.format("D"),
    ];

    let [endMonth, endDay] = [dayEndGem.format("MMM"), dayEndGem.format("D")];

    // Month of Nov
    if ((time_unit == "month" || time_unit == "quarter") && startMonth == endMonth) {
      startDay = "";
      endDay = "";
    }

    const gemStartHour = dayStartGem.format("h:mma");
    const gemEndHour = dayEndGem.clone().format("h:mma");

    const hoursText =
      gemType == "track"
        ? gemStartHour != gemEndHour
          ? `${gemStartHour} - ${gemEndHour}`
          : gemStartHour
        : "";

    const prefix =
      gemType == "track"
        ? ""
        : time_unit != "day" && time_unit != "mana"
        ? `${time_unit} of `
        : "";
    let result = `${prefix}${startMonth} ${startDay}`;
    if (startMonth !== endMonth) {
      result = `${result} - ${endMonth} ${endDay}`;
    } else if (startDay !== endDay) {
      result = `${result} - ${endDay}`;
    }

    if (hoursText) result = result + " | " + hoursText;

    return result;
  };

  const getGemText = () => {
    if (text && text.startsWith("enc:b64:")) {
      const key = getEncKey(controller);
      return decryptField(key, text);
    } else {
      return text;
    }
  };

  const onLongPressHandler = () => {
    openEditMenuOptions(item, index);
  };

  const onSelectionChanged = (item) => {
    item.isSelected = !isSelected;
    setIsSelected((prev) => !prev);
    toggleGemSelection(item.gem_id, !isSelected);
  };

  // ------------------------------------- INIT -------------------------------------
  // Interval
  const gemIntervalText = getIntervalTitle();

  // Logged
  const loggedDate = moment(datetime_created).format("H:mm, MM/DD/YYYY");

  // Icon
  const moodIcon = getMoodById(mood);

  // Text
  const gemText = getGemText();

  // Complete goals:
  const isCompleteGoal =
    editGemId == item.id && goal ? goal.is_complete : false;

  // Element: do not show element icon if it's minor or the currently visualized one
  const activities = {};
  (controller.state?.elements || []).forEach((a) => (activities[a.id] = a));

  const targetElement = inReportMode
    ? item.element
    : item?.id_element && item?.id_element != element?.id
    ? activities[item.id_element]
    : null;

  // Hours
  const goalHours =
    item && (item.id_element || item.element)
      ? hours
        ? hours
        : duration
        ? duration / 60
        : null
      : null;

  return (
    <TouchableOpacity
      onLongPress={onLongPressHandler}
      onPress={() => setIsCollapsed(!isCollapsed)}
      style={[
        styles.container,
        toggleGemSelection && !isSelected ? { opacity: 0.4 } : {},
      ]}
    >
      {isCompleteGoal ? (
        <ImageComponent
          image={require("../../../../assets/gems/GoalAchievedBg.png")}
          style={styles.imageBg}
        />
      ) : null}
      <View style={styles.content}>
        <View style={styles.iconsContainer}>
          {targetElement ? (
            <View style={styles.gemContainer}>
              {isCompleteGoal ? (
                <ImageComponent
                  image={require("../../../../assets/gems/GemBg.png")}
                  style={styles.gemBg}
                />
              ) : null}
              <ImageComponent styles={styles.icon} icon={targetElement.icon} />
            </View>
          ) : null}

          <moodIcon.Icon selected={true} width={24} height={24} />
        </View>

        {/* Text */}
        <View style={styles.textContainer}>
          <Text style={styles.intervalText}>{capitalize(gemIntervalText)}</Text>
          {targetElement ? (
            <Text style={[styles.activityName, titleStyle]}>
              {targetElement.name}
            </Text>
          ) : null}
          {loggedDate && !isCollapsed ? (
            <Text style={styles.intervalDate}>Logged: {loggedDate}</Text>
          ) : null}
          <ManaTextMore
            onLongPress={onLongPressHandler}
            text={gemText}
            size={80}
            collapsed={isCollapsed}
            onToggle={() => setIsCollapsed(!isCollapsed)}
          />
        </View>

        {/* Hours */}
        {goalHours != null ? (
          <View style={styles.hours}>
            <ManaHourMinutes duration={goalHours} center={false} />
          </View>
        ) : null}

        {toggleGemSelection ? (
          <TouchableOpacity style={styles.checkbox}>
            <RoundCheckbox
              size={16}
              checked={isSelected}
              onValueChange={() => onSelectionChanged(item)}
            />
          </TouchableOpacity>
        ) : null}
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    minHeight: 66,
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
  },
  content: {
    minHeight: 66,
    display: "flex",
    flexDirection: "row",
    paddingLeft: 0,
    paddingVertical: 10,
    paddingRight: 0,
  },
  textContainer: {
    marginLeft: 8,
    display: "flex",
    justifyContent: "center",
    flex: 1,
  },
  intervalText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  intervalDate: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  activityName: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  imageBg: {
    position: "absolute",
    left: 0,
    top: 0,
    height: 85,
    width: "100%",
  },
  iconsContainer: {
    maxHeight: 66,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 4,
  },
  gemContainer: {
    position: "relative",
    width: 26,
    height: 26,
    marginBottom: 4,
  },
  icon: {
    position: "absolute",
    left: 2,
    top: 0,
    width: 24,
    height: 24,
  },
  gemBg: {
    width: 24,
    height: 24,
    position: "absolute",
    left: 1,
    top: 0,
    borderRadius: 13,
    borderWidth: 2,
    borderColor: AppTheme.DEFAULT_COLOR,
  },
  hours: {
    maxHeight: 65,
    minWidth: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
